import Request from './request';
import { MeetFileUploadRes } from 'type/meeting';
import { Subject } from 'rxjs';
import axios from 'axios';
import { downloadByBlob } from 'util/download';

const request = new Request('file');
const downloadAxios = axios.create();

/**
 * 上传文件
 * @param accessKey 会议accessKey
 * @param formData 文件form
 */
export const uploadFile = (formData: FormData) => {
  const fileSubject = new Subject<[number, MeetFileUploadRes | null]>();
  request.post<MeetFileUploadRes>('/api/file/upload', formData, {
    headers: {
      // 'x-share-key': accessKey
    },
    onUploadProgress: (progressEvent) => {
      if (progressEvent.lengthComputable) {
        const complete = ((progressEvent.loaded / progressEvent.total) * 100) | 0;
        let percent = complete;
        if (complete >= 100) {
          percent = 100;
        }
        fileSubject.next([percent, null]);
      }
    }
  }).subscribe(
    res => {
      fileSubject.next([100, res]);
      fileSubject.complete();
    },
    err => {
      fileSubject.error(err);
    }
  );
  return fileSubject;
};

export const downloadFile = (url: string, filename: string) => {
  return downloadAxios.get<Blob>(url, {
    responseType: 'blob'
  }).then((data) => {
    downloadByBlob(data.data, filename);
  });
};

export enum viewType {
  PC = 0,
  MOBILE = 1
}

export enum isAsync {
  NO = 0,
  YES = 1
}

export enum isHD {
  NO = 0,
  YES = 1
}

// 获取文件预览url
export const getPreviewUrl = (fileId: string, options: { fileName: string; viewType: viewType; isAsync: isAsync; isHD: isHD }) => {
  return request.get<{ code: number; url: string }>(`/api/file/preview/${fileId}`, { params: options });
};
